export default [
  { id: '002', name: 'email', desc: 'ui-users.data.contactTypes.email' },
  { id: '001', name: 'mail', desc: 'ui-users.data.contactTypes.mail' },
  { id: '003', name: 'sms', desc: 'ui-users.data.contactTypes.textMessage' },
];
